import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/installningar/")({
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/installningar/aviseringar", search });
  },
});
